import { displayMessage } from "../event/Actions";
import { signIn } from "../event/SecurityActions";

export function errorHandler(err) {
  let status;
  let message = err.message;
  const response = err.response;

  if (response) {
    status = response.status;
    message = response.data.message;
  }

  if (status === 401 || status === 403 || status === 440) {
    signIn();
    return;
  }

  console.error("ERROR", message, err);
  displayMessage({ text: message, variant: "error" });
  return err;
}
